module.exports = __webpack_public_path__ + "img/desc3.9df14843.png";